var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMennekesPlug(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 64,
    viewBox: "0 0 74 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6_17605)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M70.9006 28.19C70.9006 45.6821 56.0109 59.8602 37.6415 59.8602C19.2722 59.8602 4.37717 45.6821 4.37717 28.19C4.37717 18.0712 7.78808 10.2422 15.3386 6.17747C20.8351 3.21743 29.1512 2.67047 36.8865 2.67047C44.6218 2.67047 52.526 2.96004 58.2866 5.83428C66.3967 9.87751 70.8953 17.964 70.8953 28.19H70.9006Z",
    fill: "#1E272D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.9921 59.6297C19.2616 59.6297 4.83653 45.8001 4.83653 28.8067C4.83653 20.377 8.32137 12.5051 14.6469 6.64399C17.8572 3.66787 28.6918 2.61148 36.9974 2.61148C45.3029 2.61148 56.1376 3.66787 59.3478 6.64399C65.6734 12.5051 69.1529 20.377 69.1529 28.8067C69.1529 45.8055 54.7278 59.6297 36.9974 59.6297H36.9921ZM36.9921 2.74018C26.0888 2.74018 17.3503 4.31136 14.7261 6.73515C8.42697 12.5748 4.95797 20.4092 4.95797 28.8067C4.95797 45.7357 19.325 59.5063 36.9921 59.5063C54.6591 59.5063 69.0262 45.7357 69.0262 28.8067C69.0262 20.4146 65.5572 12.5748 59.2581 6.73515C56.6392 4.30599 47.9007 2.74018 36.9921 2.74018Z",
    fill: "#1E272D"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.27
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.721 54.5032C26.4742 58.9701 35.0015 60.981 43.703 59.4688C56.4174 57.2648 65.9902 48.1541 69.0103 36.9039C67.5583 34.1208 64.9553 31.8042 61.9932 30.4047C57.5632 28.3026 52.4627 27.9165 47.51 27.9755C42.0557 28.0345 36.5222 28.6029 31.4586 30.5387C26.395 32.4692 21.8014 35.8904 19.3936 40.5503C17.1391 44.9099 17.0651 50.401 19.721 54.5086V54.5032Z",
    fill: "#31404C"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.26
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.58837 29.4395C4.58837 16.9129 19.1877 6.76196 37.198 6.76196C55.2083 6.76196 69.8076 16.9183 69.8076 29.4395C69.8076 30.3082 69.7284 31.1608 69.5964 32.0027C71.0221 29.3537 71.8088 26.4848 71.8088 23.4819C71.8088 16.1408 67.1307 9.56112 59.7439 5.13179C53.7088 1.51219 19.2564 1.9948 13.0206 6.31688C6.71623 10.6979 2.80371 16.7682 2.80371 23.4819C2.80371 26.2649 3.48484 28.93 4.72037 31.4182C4.64117 30.764 4.58837 30.1044 4.58837 29.4395Z",
    fill: "#0D1214"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.23
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.3576 20.5969C23.4699 27.9058 33.9191 32.1528 44.3842 31.9866C48.5343 31.9222 53.0435 31.2734 56.5494 33.3915C60.4725 35.7617 61.613 41.0705 59.992 45.2156C58.371 49.3607 54.5641 52.428 50.4404 54.471C38.9246 60.182 23.8764 58.643 13.8918 50.7388C5.73942 44.2932 2.10146 34.7321 2.02754 24.8653C2.00642 21.9911 1.19329 17.047 4.13957 15.1541C8.75962 12.194 13.6859 17.8514 16.3576 20.5969Z",
    fill: "#0D1214"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M57.5579 3.53915C56.0267 2.61146 54.2526 2.10203 52.431 2.05377L46.4434 1.90363H22.6356C18.4908 1.90363 14.536 3.54988 11.727 6.43484C5.82918 12.4836 2.30211 20.6666 2.62947 29.7076C3.1786 44.9367 17.2394 59.2704 33.2274 60.9059C53.2599 62.9597 70.5996 48.5188 71.3653 29.7719C71.7824 19.5083 66.4231 8.91762 57.5526 3.54451L57.5579 3.53915ZM66.6132 29.595C65.9585 45.7464 51.0212 58.1872 33.766 56.4229C19.0029 54.9161 7.56632 42.9848 7.37096 28.9193C7.27592 22.0876 9.74171 15.8619 13.8813 10.9875C16.3576 8.065 20.1223 6.39194 24.0771 6.39194H50.0655C53.8777 6.39194 57.5315 7.96848 59.9445 10.7623C64.3586 15.8726 66.9036 22.4737 66.6132 29.595Z",
    fill: "#445B68"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.39
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58.6826 2.12349C57.1725 1.20653 56.4808 0.664926 54.6961 0.557678L54.5008 2.02161H19.7052V0.557678C16.1359 1.02421 12.8147 2.63828 10.3384 5.18005C4.11845 11.5559 0.401285 20.1893 0.749769 29.7237C1.33057 45.784 16.1623 60.9059 33.0268 62.6326C54.1576 64.799 72.4477 49.5698 73.2555 29.7934C73.6938 18.9667 68.0441 7.79689 58.6878 2.12886L58.6826 2.12349ZM33.5864 57.9083C18.0156 56.3211 5.95063 43.7356 5.7447 28.8925C5.64438 21.6908 8.24217 15.1219 12.6088 9.97402C15.2224 6.89065 19.0452 6.49919 23.2164 6.49919H50.6305C54.6539 6.49919 58.503 8.16153 61.0533 11.1108C65.7103 16.5054 68.5404 22.0876 68.2342 29.6003C67.5425 46.6366 51.7868 59.7584 33.5864 57.903V57.9083Z",
    fill: "#0D1214"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M59.1152 1.76422C57.4679 0.761458 55.5565 0.209133 53.6029 0.160871L47.1612 0H21.5423C17.086 0 12.8302 1.78031 9.80478 4.89585C3.45815 11.4326 -0.327654 20.2859 0.0208299 30.0561C0.612196 46.5186 15.7396 62.0159 32.942 63.7855C54.4952 66.0055 73.1496 50.3956 73.9733 30.1205C74.4221 19.0204 68.6563 7.57704 59.1152 1.75886V1.76422ZM68.8569 29.9382C68.1494 47.4034 52.0822 60.8523 33.5175 58.9486C17.6351 57.3185 5.32729 44.4166 5.12137 29.2089C5.02104 21.8249 7.67163 15.0951 12.1227 9.81852C14.7891 6.66008 18.839 4.84759 23.0947 4.84759H51.0579C55.1605 4.84759 59.0888 6.55283 61.6866 9.57721C66.4387 15.1058 69.1737 22.2378 68.8622 29.9435L68.8569 29.9382Z",
    fill: "#4F6B77"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.14
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64.913 7.18024C74.0581 16.9934 75.8322 32.0831 69.5964 43.7195C67.5372 47.5858 64.6965 51.0659 61.2645 53.8597C64.4167 50.8139 67.0726 47.3016 68.9628 43.4299C74.7709 31.7936 73.076 17.4331 64.913 7.18024Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.14
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.9407 59.3991C3.04131 51.7416 -4.67813 30.4905 4.04453 13.8296C6.80072 8.47791 11.0459 3.81264 16.2731 0.557678C11.2888 4.09685 7.2548 8.78893 4.67813 14.1191C-3.54292 30.6299 3.91252 51.0391 20.9407 59.3991Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.39
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.9799 28.989C47.9799 24.5543 51.6178 20.9562 56.1006 20.9562C60.5834 20.9562 64.2213 24.5543 64.2213 28.989C64.2213 33.4237 60.5834 37.0219 56.1006 37.0219C51.6178 37.0219 47.9799 33.4237 47.9799 28.989Z",
    fill: "#0D1214"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M56.5072 35.5794C60.9921 35.5794 64.6279 32.1174 64.6279 27.8468C64.6279 23.5763 60.9921 20.1143 56.5072 20.1143C52.0222 20.1143 48.3864 23.5763 48.3864 27.8468C48.3864 32.1174 52.0222 35.5794 56.5072 35.5794Z",
    fill: "#445B68"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.39
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56.5072 32.9787C59.4845 32.9787 61.8981 30.6811 61.8981 27.8469C61.8981 25.0126 59.4845 22.7151 56.5072 22.7151C53.5298 22.7151 51.1162 25.0126 51.1162 27.8469C51.1162 30.6811 53.5298 32.9787 56.5072 32.9787Z",
    fill: "#0D1214"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.18
  }, /*#__PURE__*/React.createElement("path", {
    d: "M62.7376 23.2298C66.3545 27.1926 64.2583 33.5846 59.1947 35.0378C63.6247 32.7266 65.4041 27.6431 62.8432 23.3532L62.7376 23.2298Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.18
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.7267 34.4533C46.2111 31.4664 47.3146 22.211 54.4902 20.6183C48.0908 23.0046 47.209 30.7961 52.7267 34.4533Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M52.1617 27.7021C52.1617 25.4177 54.1047 23.5677 56.5072 23.5677C58.9096 23.5677 60.8527 25.4177 60.8527 27.7021C60.8527 29.9864 58.9096 31.8364 56.5072 31.8364C54.1047 31.8364 52.1617 29.9864 52.1617 27.7021Z",
    fill: "url(#paint0_linear_6_17605)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.39
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.3966 43.4138C38.3966 38.9791 42.0345 35.381 46.5173 35.381C51.0001 35.381 54.638 38.9791 54.638 43.4138C54.638 47.8485 51.0001 51.4467 46.5173 51.4467C42.0345 51.4467 38.3966 47.8485 38.3966 43.4138Z",
    fill: "#0D1214"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M38.8031 42.2716C38.8031 38.0032 42.4411 34.5391 46.9239 34.5391C51.4066 34.5391 55.0446 37.9978 55.0446 42.2716C55.0446 46.5454 51.4066 50.0042 46.9239 50.0042C42.4411 50.0042 38.8031 46.5401 38.8031 42.2716Z",
    fill: "#445B68"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.39
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.5329 42.2716C41.5329 39.4403 43.9459 37.1398 46.9239 37.1398C49.9018 37.1398 52.3148 39.4349 52.3148 42.2716C52.3148 45.1083 49.9018 47.4034 46.9239 47.4034C43.9459 47.4034 41.5329 45.1083 41.5329 42.2716Z",
    fill: "#0D1214"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.18
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.1543 37.6493C56.7712 41.6121 54.675 47.9987 49.6114 49.4573C54.0414 47.1461 55.8208 42.0625 53.2599 37.7726L53.1543 37.6493Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.18
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.1433 48.8781C36.6278 45.8912 37.7313 36.6358 44.9069 35.0432C38.5075 37.4294 37.6257 45.221 43.1433 48.8781Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M42.5784 42.1268C42.5784 39.8425 44.5214 37.9924 46.9239 37.9924C49.3263 37.9924 51.2694 39.8425 51.2694 42.1268C51.2694 44.4112 49.3263 46.2612 46.9239 46.2612C44.5214 46.2612 42.5784 44.4112 42.5784 42.1268Z",
    fill: "url(#paint1_linear_6_17605)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.39
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.4116 43.4138C18.4116 38.9791 22.0495 35.381 26.5323 35.381C31.0151 35.381 34.653 38.9791 34.653 43.4138C34.653 47.8485 31.0151 51.4467 26.5323 51.4467C22.0495 51.4467 18.4116 47.8485 18.4116 43.4138Z",
    fill: "#0D1214"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M18.8181 42.2716C18.8181 38.0032 22.4561 34.5391 26.9389 34.5391C31.4216 34.5391 35.0596 37.9978 35.0596 42.2716C35.0596 46.5454 31.4216 50.0042 26.9389 50.0042C22.4561 50.0042 18.8181 46.5401 18.8181 42.2716Z",
    fill: "#445B68"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.39
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.5479 42.2716C21.5479 39.4403 23.9609 37.1398 26.9389 37.1398C29.9168 37.1398 32.3298 39.4349 32.3298 42.2716C32.3298 45.1083 29.9168 47.4034 26.9389 47.4034C23.9609 47.4034 21.5479 45.1083 21.5479 42.2716Z",
    fill: "#0D1214"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.18
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.1693 37.6493C36.7862 41.6121 34.69 47.9987 29.6264 49.4573C34.0564 47.1461 35.8358 42.0625 33.2749 37.7726L33.1693 37.6493Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.18
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.1583 48.8781C16.6427 45.8912 17.7463 36.6358 24.9219 35.0432C18.5224 37.4294 17.6407 45.221 23.1583 48.8781Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M22.5934 42.1268C22.5934 39.8425 24.5364 37.9924 26.9389 37.9924C29.3413 37.9924 31.2843 39.8425 31.2843 42.1268C31.2843 44.4112 29.3413 46.2612 26.9389 46.2612C24.5364 46.2612 22.5934 44.4112 22.5934 42.1268Z",
    fill: "url(#paint2_linear_6_17605)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.39
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.5493 28.989C28.5493 24.5543 32.1872 20.9562 36.67 20.9562C41.1528 20.9562 44.7907 24.5543 44.7907 28.989C44.7907 33.4237 41.1528 37.0219 36.67 37.0219C32.1872 37.0219 28.5493 33.4237 28.5493 28.989Z",
    fill: "#0D1214"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M37.0713 35.5794C41.5562 35.5794 45.192 32.1174 45.192 27.8468C45.192 23.5763 41.5562 20.1143 37.0713 20.1143C32.5863 20.1143 28.9506 23.5763 28.9506 27.8468C28.9506 32.1174 32.5863 35.5794 37.0713 35.5794Z",
    fill: "#445B68"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.39
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.0713 32.9787C40.0486 32.9787 42.4622 30.6811 42.4622 27.8469C42.4622 25.0126 40.0486 22.7151 37.0713 22.7151C34.0939 22.7151 31.6803 25.0126 31.6803 27.8469C31.6803 30.6811 34.0939 32.9787 37.0713 32.9787Z",
    fill: "#0D1214"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.18
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.3018 23.2298C46.9186 27.1926 44.8224 33.5846 39.7588 35.0378C44.1888 32.7266 45.9682 27.6431 43.4074 23.3532L43.3018 23.2298Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.18
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.2908 34.4533C26.7752 31.4664 27.8787 22.211 35.0543 20.6183C28.6549 23.0046 27.7731 30.7961 33.2908 34.4533Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M32.7311 27.7021C32.7311 25.4177 34.6741 23.5677 37.0766 23.5677C39.479 23.5677 41.4221 25.4177 41.4221 27.7021C41.4221 29.9864 39.479 31.8364 37.0766 31.8364C34.6741 31.8364 32.7311 29.9864 32.7311 27.7021Z",
    fill: "url(#paint3_linear_6_17605)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.39
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.1466 14.1352C21.1466 11.0465 23.6758 8.54764 26.7963 8.54764C29.9168 8.54764 32.446 11.0519 32.446 14.1352C32.446 17.2186 29.9168 19.7228 26.7963 19.7228C23.6758 19.7228 21.1466 17.2186 21.1466 14.1352Z",
    fill: "#0D1214"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M21.4265 13.3416C21.4265 10.3708 23.9556 7.96313 27.0761 7.96313C30.1966 7.96313 32.7258 10.3708 32.7258 13.3416C32.7258 16.3124 30.1966 18.7201 27.0761 18.7201C23.9556 18.7201 21.4265 16.3124 21.4265 13.3416Z",
    fill: "#445B68"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.39
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.3273 13.3416C23.3273 11.3683 25.0064 9.77026 27.0761 9.77026C29.1459 9.77026 30.825 11.3683 30.825 13.3416C30.825 15.315 29.1459 16.913 27.0761 16.913C25.0064 16.913 23.3273 15.315 23.3273 13.3416Z",
    fill: "#0D1214"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.18
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.4163 10.1241C33.9296 12.8804 32.4776 17.3312 28.9506 18.3447C32.0341 16.736 33.2696 13.1968 31.4903 10.2099L31.4163 10.1241Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.18
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.4467 17.9371C19.9111 15.8565 20.682 9.41633 25.6769 8.31168C21.2206 9.97401 20.6133 15.3954 24.4467 17.9371Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M24.0559 13.2397C24.0559 11.6524 25.4076 10.3601 27.0814 10.3601C28.7552 10.3601 30.1069 11.6471 30.1069 13.2397C30.1069 14.8323 28.7552 16.1193 27.0814 16.1193C25.4076 16.1193 24.0559 14.8323 24.0559 13.2397Z",
    fill: "url(#paint4_linear_6_17605)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.39
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.2056 14.1352C41.2056 11.0465 43.7347 8.54764 46.8552 8.54764C49.9757 8.54764 52.5049 11.0519 52.5049 14.1352C52.5049 17.2186 49.9757 19.7228 46.8552 19.7228C43.7347 19.7228 41.2056 17.2186 41.2056 14.1352Z",
    fill: "#0D1214"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M47.1351 18.7201C50.2553 18.7201 52.7847 16.312 52.7847 13.3416C52.7847 10.3712 50.2553 7.96313 47.1351 7.96313C44.0149 7.96313 41.4854 10.3712 41.4854 13.3416C41.4854 16.312 44.0149 18.7201 47.1351 18.7201Z",
    fill: "#445B68"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.39
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.3862 13.3416C43.3862 11.3683 45.0653 9.77026 47.1351 9.77026C49.2049 9.77026 50.8839 11.3683 50.8839 13.3416C50.8839 15.315 49.2049 16.913 47.1351 16.913C45.0653 16.913 43.3862 15.315 43.3862 13.3416Z",
    fill: "#0D1214"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.18
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51.47 10.1241C53.9886 12.8804 52.5313 17.3312 49.0042 18.3447C52.0878 16.736 53.3233 13.1968 51.5439 10.2099L51.47 10.1241Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.18
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.5056 17.9371C39.97 15.8565 40.7409 9.41633 45.7359 8.31168C41.2795 9.97401 40.6723 15.3954 44.5056 17.9371Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M47.1351 16.1193C48.806 16.1193 50.1605 14.8301 50.1605 13.2397C50.1605 11.6493 48.806 10.3601 47.1351 10.3601C45.4641 10.3601 44.1096 11.6493 44.1096 13.2397C44.1096 14.8301 45.4641 16.1193 47.1351 16.1193Z",
    fill: "url(#paint5_linear_6_17605)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.39
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.11338 28.989C9.11338 24.5543 12.7513 20.9562 17.2341 20.9562C21.7169 20.9562 25.3548 24.5543 25.3548 28.989C25.3548 33.4237 21.7169 37.0219 17.2341 37.0219C12.7513 37.0219 9.11338 33.4237 9.11338 28.989Z",
    fill: "#0D1214"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M9.51994 27.8468C9.51994 23.5784 13.1579 20.1143 17.6407 20.1143C22.1234 20.1143 25.7614 23.573 25.7614 27.8468C25.7614 32.1207 22.1234 35.5794 17.6407 35.5794C13.1579 35.5794 9.51994 32.1207 9.51994 27.8468Z",
    fill: "#445B68"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.39
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.6407 32.9787C20.618 32.9787 23.0316 30.6811 23.0316 27.8469C23.0316 25.0126 20.618 22.7151 17.6407 22.7151C14.6633 22.7151 12.2497 25.0126 12.2497 27.8469C12.2497 30.6811 14.6633 32.9787 17.6407 32.9787Z",
    fill: "#0D1214"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.18
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.8711 23.2298C27.488 27.1926 25.3918 33.5846 20.3282 35.0378C24.7582 32.7266 26.5376 27.6431 23.9767 23.3532L23.8711 23.2298Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.18
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.8601 34.4533C7.34456 31.4664 8.44809 22.211 15.6237 20.6183C9.22426 23.0046 8.34249 30.7961 13.8601 34.4533Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M13.2952 27.7021C13.2952 25.4177 15.2382 23.5677 17.6407 23.5677C20.0431 23.5677 21.9862 25.4177 21.9862 27.7021C21.9862 29.9864 20.0431 31.8364 17.6407 31.8364C15.2382 31.8364 13.2952 29.9864 13.2952 27.7021Z",
    fill: "url(#paint6_linear_6_17605)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6_17605",
    x1: 56.5072,
    y1: 23.5677,
    x2: 56.5072,
    y2: 31.8418,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8F3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDE3B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6_17605",
    x1: 46.9239,
    y1: 37.9924,
    x2: 46.9239,
    y2: 46.2612,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8F3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDE3B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_6_17605",
    x1: 26.9389,
    y1: 37.9924,
    x2: 26.9389,
    y2: 46.2612,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8F3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDE3B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_6_17605",
    x1: 37.0713,
    y1: 0.00000280767,
    x2: 37.0713,
    y2: 0.00000280767,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8F3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDE3B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_6_17605",
    x1: 27.0761,
    y1: 10.3601,
    x2: 27.0761,
    y2: 16.1193,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8F3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDE3B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_6_17605",
    x1: 47.1351,
    y1: 10.3601,
    x2: 47.1351,
    y2: 16.1193,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8F3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDE3B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_6_17605",
    x1: 17.6407,
    y1: 23.7446,
    x2: 17.6407,
    y2: 32.067,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8F3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDE3B"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6_17605"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 74,
    height: 64,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMennekesPlug);
export default __webpack_public_path__ + "static/media/mennekes_plug.cd0251de96a7fe3e24f3e218280d9de8.svg";
export { ForwardRef as ReactComponent };